import { render, staticRenderFns } from "./piclist.vue?vue&type=template&id=65a22f21&"
import script from "./piclist.vue?vue&type=script&lang=js&"
export * from "./piclist.vue?vue&type=script&lang=js&"
import style0 from "./piclist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports